export interface ResourceConfig {
  value: string;
  name: string;
  description: string;
  route?: string;
  parent?: string;
  icon?: string;
}

export const RBAC_RESOURCES = {
  sales: {
    value: 'sales',
    name: 'План продаж',
    description: 'Общий доступ к планированию продаж',
    route: '/sales',
    icon: 'LineChartOutlined'
  },
  
  sales_stage1: {
    value: 'sales_stage1',
    name: 'Продажи: Этап 1 - БГ',
    description: 'Этап 1: Планирование по бизнес-группам',
    parent: 'sales'
  },
  
  sales_stage2: {
    value: 'sales_stage2',
    name: 'Продажи: Этап 2 - ТН/ЦПР',
    description: 'Этап 2: Планирование по ТН/ЦПР',
    parent: 'sales'
  },
  
  sales_stage3: {
    value: 'sales_stage3',
    name: 'Продажи: Этап 3 - Контроль',
    description: 'Этап 3: Контроль периодов',
    parent: 'sales'
  },
  
  sales_stage4: {
    value: 'sales_stage4',
    name: 'Продажи: Этап 4 - Распределение',
    description: 'Этап 4: Распределение по БГ',
    parent: 'sales'
  },
  
  sales_stage5: {
    value: 'sales_stage5',
    name: 'Продажи: Этап 5 - Менеджеры',
    description: 'Этап 5: Планирование менеджеров',
    parent: 'sales'
  },

  // Права утверждения — намеренно БЕЗ parent: право write на этап
  // не должно автоматически давать право утверждать (и наоборот).
  sales_stage3_approve: {
    value: 'sales_stage3_approve',
    name: 'Продажи: Утверждение плана (Этап 3)',
    description: 'Кнопка «Утвердить» на этапе 3 — создание утверждённой версии плана'
  },

  sales_stage4_approve: {
    value: 'sales_stage4_approve',
    name: 'Продажи: Утверждение плана (Этап 4)',
    description: 'Кнопка «Утвердить» на этапе 4 — создание утверждённой версии плана'
  },

  sales_stage4_mp_approve: {
    value: 'sales_stage4_mp_approve',
    name: 'Продажи: Утверждение плана по МП в разрезе ЦПР-ТН-SKU (Этап 4)',
    description: 'Кнопка «Утвердить» на экране «Распределение по МП» этапа 4 — создание утверждённой версии 4s2s'
  },

  sales_stage4_calculate: {
    value: 'sales_stage4_calculate',
    name: 'Продажи: Расчёт мотивационного ПП (Этап 4)',
    description: 'Кнопка «Рассчитать» на вкладке Мотивационный ПП этапа 4'
  },

  // Без parent: запись на продажи/этапы не даёт права видеть и выбирать методологию.
  // По умолчанию — только администраторы (PLNG-BACKEND/sql/20261013_calc_methodology_rbac.sql).
  // Описание показывается в админке прав ролей под названием ресурса.
  sales_calc_methodology: {
    value: 'sales_calc_methodology',
    name: 'Продажи: Методология расчёта (этапы 2–4) — видимость и выбор',
    description: '«Нет доступа» — переключатель в шапке скрыт (описание математики в ⓘ видно всем); «Чтение» — видна текущая методология (и в утверждённых версиях этапов 3–4) и журнал переключений; «Редакт.»/«Полное» — можно переключать'
  },

  sales_stage5_approve: {
    value: 'sales_stage5_approve',
    name: 'Продажи: Утверждение плана (Этап 5)',
    description: 'Кнопка «Утвердить план» на этапе 5 — создание утверждённой версии плана'
  },

  sales_stage5_actualize: {
    value: 'sales_stage5_actualize',
    name: 'Продажи: Актуализация Дин.ПП (Этап 5)',
    description: 'Кнопка «Готово» в сводке динамического плана продаж этапа 5'
  },

  sales_stage6: {
    value: 'sales_stage6',
    name: 'Продажи: Этап 6',
    description: 'Этап 6: Планирование продаж',
    parent: 'sales'
  },

  purchase: {
    value: 'purchase',
    name: 'План закупок',
    description: 'Общий доступ к планированию закупок',
    route: '/purchase',
    icon: 'ShoppingOutlined'
  },
  
  purchase_stage1: {
    value: 'purchase_stage1',
    name: 'Закупки: Этап 1 - ТН/ЦПР',
    description: 'Этап 1: Планирование закупок по ТН/ЦПР',
    parent: 'purchase'
  },
  
  purchase_stage2: {
    value: 'purchase_stage2',
    name: 'Закупки: Этап 2',
    description: 'Этап 2: Планирование закупок (детализация)',
    parent: 'purchase'
  },

  reconciliation: {
    value: 'reconciliation',
    name: 'Сверка',
    description: 'Сверка планов продаж и закупок',
    route: '/reconciliation',
    icon: 'CheckCircleOutlined'
  },

  // Экраны представления «Сверка ПП и ПЗ». Без parent: модульный reconciliation:read
  // (есть у КД/ДЗ/ФАО) не должен открывать их — выдаются ролям явно в админке.
  // SQL: PLNG-BACKEND/sql/20261012_reconciliation_screens.sql
  reconciliation_sales_purchase: {
    value: 'reconciliation_sales_purchase',
    name: 'Сверка: экран «Сверка ПП и ПЗ»',
    description: 'План закупок в ценах закупки против плана продаж в ценах продаж по ЦПР и ЦПР-ТН'
  },

  reconciliation_purchase: {
    value: 'reconciliation_purchase',
    name: 'Сверка: экран «Сверка закупки»',
    description: 'План закупок и план продаж в ценах закупки по ЦПР и ЦПР-ТН'
  },

  reconciliation_periods: {
    value: 'reconciliation_periods',
    name: 'Сверка: Контроль периодов',
    description: 'Контроль остатков и планов по периодам',
    parent: 'reconciliation'
  },

  reconciliation_dyn_plan_cpr_tn_sku: {
    value: 'reconciliation_dyn_plan_cpr_tn_sku',
    name: 'Сверка: Дин.план ЦПР-ТН-SKU',
    description: 'Сверка планового объема от КД с динамическим планированием от БГ по ЦПР-ТН-SKU',
    parent: 'reconciliation'
  },

  reconciliation_dpz_dpp_tmz: {
    value: 'reconciliation_dpz_dpp_tmz',
    name: 'Сверка: ДПЗ и ДПП с учетом ТМЗ',
    description: 'Сверка динамического плана закупок и плана продаж с учетом ТМЗ по ЦПР-ТН-SKU',
    parent: 'reconciliation'
  },

  references: {
    value: 'references',
    name: 'Справочники',
    description: 'Общий доступ к справочникам системы',
    route: '/references',
    icon: 'BookOutlined'
  },

  references_assortment: {
    value: 'references_assortment',
    name: 'Справочники: Ключевой ассортимент',
    description: 'Управление ключевым ассортиментом (ТН, ЦПР, ЕП)',
    parent: 'references'
  },

  references_pricing: {
    value: 'references_pricing',
    name: 'Справочники: Цены',
    description: 'Планирование и корректировка цен (упаковки и граммы)',
    parent: 'references'
  },

  references_shipment: {
    value: 'references_shipment',
    name: 'Справочники: % отгрузки',
    description: 'Проценты отгрузки по бизнес-группам',
    parent: 'references'
  },

  references_suppliers: {
    value: 'references_suppliers',
    name: 'Справочники: Поставщики-КНП',
    description: 'Управление поставщиками и коэффициентами наценки',
    parent: 'references'
  },

  references_clients: {
    value: 'references_clients',
    name: 'Справочники: Управление клиентами',
    description: 'Назначение менеджеров на партнёров (руководители и директор)',
    parent: 'references',
    icon: 'TeamOutlined'
  },

  references_pricing_pack: {
    value: 'references_pricing_pack',
    name: 'Цены: Планирование (упаковки)',
    description: 'Планирование цен по упаковкам',
    parent: 'references_pricing'
  },

  references_pricing_gram: {
    value: 'references_pricing_gram',
    name: 'Цены: Планирование (граммы)',
    description: 'Планирование цен по граммам',
    parent: 'references_pricing'
  },

  references_correction_pack: {
    value: 'references_correction_pack',
    name: 'Цены: Корректировка (упаковки)',
    description: 'Корректировка цен по упаковкам',
    parent: 'references_pricing'
  },

  references_correction_gram: {
    value: 'references_correction_gram',
    name: 'Цены: Корректировка (граммы)',
    description: 'Корректировка цен по граммам',
    parent: 'references_pricing'
  },

  references_approval: {
    value: 'references_approval',
    name: 'Справочники: Дата старта планирования',
    description: 'Управление датой старта динамического планирования',
    parent: 'references'
  },

  references_actualization: {
    value: 'references_actualization',
    name: 'Справочники: Актуализация динамического плана',
    description: 'Дедлайны актуализации динамического плана и аналитика нажатий менеджеров',
    parent: 'references',
    icon: 'CheckSquareOutlined'
  },

  // Таблицы: Продажи - Этап 1
  sales_stage1_planning: {
    value: 'sales_stage1_planning',
    name: 'Этап 1: Планирование БГ',
    description: 'Таблица планирования по бизнес-группам (₽)',
    parent: 'sales_stage1'
  },
  sales_stage1_kn: {
    value: 'sales_stage1_kn',
    name: 'Этап 1: Коэффициент наценки',
    description: 'Таблица коэффициента наценки (%, ₽)',
    parent: 'sales_stage1'
  },
  sales_stage1_analytics: {
    value: 'sales_stage1_analytics',
    name: 'Этап 1: Аналитика БГ',
    description: 'Аналитика по бизнес-группам',
    parent: 'sales_stage1'
  },
  sales_stage1_cpr: {
    value: 'sales_stage1_cpr',
    name: 'Этап 1: ЦПР',
    description: 'Планирование по ЦПР',
    parent: 'sales_stage1'
  },
  sales_stage1_periods: {
    value: 'sales_stage1_periods',
    name: 'Этап 1: Периоды БГ',
    description: 'План БГ по периодам',
    parent: 'sales_stage1'
  },

  // Таблицы: Продажи - Этап 2
  sales_stage2_tn: {
    value: 'sales_stage2_tn',
    name: 'Этап 2: Планирование ТН',
    description: 'План продаж по торговым наименованиям',
    parent: 'sales_stage2'
  },
  sales_stage2_periods: {
    value: 'sales_stage2_periods',
    name: 'Этап 2: Периоды',
    description: 'План БГ-ЦПР-ТН по периодам',
    parent: 'sales_stage2'
  },
  sales_stage2_analytics: {
    value: 'sales_stage2_analytics',
    name: 'Этап 2: Аналитика',
    description: 'Аналитика по ЦПР-ТН',
    parent: 'sales_stage2'
  },

  // Таблицы: Продажи - Этап 3
  sales_stage3_plan: {
    value: 'sales_stage3_plan',
    name: 'Этап 3: План продаж',
    description: 'План продаж по БГ, ТН, ЦПР, SKU',
    parent: 'sales_stage3'
  },

  // Таблицы: Продажи - Этап 4
  sales_stage4_revenue: {
    value: 'sales_stage4_revenue',
    name: 'Этап 4: Выручка',
    description: 'Выручка по менеджерам',
    parent: 'sales_stage4'
  },
  sales_stage4_knr: {
    value: 'sales_stage4_knr',
    name: 'Этап 4: КНР',
    description: 'КНР по менеджерам',
    parent: 'sales_stage4'
  },
  sales_stage4_mp_distribution: {
    value: 'sales_stage4_mp_distribution',
    name: 'Этап 4: Распределение МП',
    description: 'Распределение плана продаж по менеджерам',
    parent: 'sales_stage4'
  },
  sales_stage4_summary: {
    value: 'sales_stage4_summary',
    name: 'Этап 4: Сводка',
    description: 'Сводка по распределению',
    parent: 'sales_stage4'
  },
  sales_stage4_knr_summary: {
    value: 'sales_stage4_knr_summary',
    name: 'Этап 4: Сводка КНР',
    description: 'Сводка КНР по распределению',
    parent: 'sales_stage4'
  },
  sales_stage4_vpkpi_summary: {
    value: 'sales_stage4_vpkpi_summary',
    name: 'Этап 4: Сводка ВП KPI',
    description: 'Сводная аналитика ВП KPI по распределению',
    parent: 'sales_stage4'
  },
  sales_stage4_vpkpi: {
    value: 'sales_stage4_vpkpi',
    name: 'Этап 4: ВП KPI',
    description: 'ВП KPI по менеджерам',
    parent: 'sales_stage4'
  },
  sales_stage4_verification: {
    value: 'sales_stage4_verification',
    name: 'Этап 4: Верификация',
    description: 'Верификация распределения',
    parent: 'sales_stage4'
  },

  // Таблицы: Продажи - Этап 5
  sales_stage5_plan: {
    value: 'sales_stage5_plan',
    name: 'Этап 5: План менеджеров',
    description: 'План продаж менеджеров по месяцам',
    parent: 'sales_stage5'
  },
  sales_stage5_knr: {
    value: 'sales_stage5_knr',
    name: 'Этап 5: КНР',
    description: 'КНР по менеджерам и партнёрам',
    parent: 'sales_stage5'
  },
  sales_stage5_dynamic: {
    value: 'sales_stage5_dynamic',
    name: 'Этап 5: Динамический план',
    description: 'Динамический план продаж по месяцам',
    parent: 'sales_stage5'
  },
  sales_stage5_analytics: {
    value: 'sales_stage5_analytics',
    name: 'Этап 5: Аналитика',
    description: 'Статистика по партнёрам, ТН, ЦПР',
    parent: 'sales_stage5'
  },
  sales_stage3_versions: {
    value: 'sales_stage3_versions',
    name: 'Этап 3: Версии',
    description: 'Просмотр и экспорт утверждённых версий распределения плана по БГ',
    parent: 'sales_stage3'
  },
  sales_stage5_versions: {
    value: 'sales_stage5_versions',
    name: 'Этап 5: Версии',
    description: 'Утверждённые версии планов',
    parent: 'sales_stage5'
  },

  // Таблицы: Закупки - Этап 1
  purchase_stage1_tn: {
    value: 'purchase_stage1_tn',
    name: 'Закупки: Планирование ТН',
    description: 'План закупок по торговым наименованиям',
    parent: 'purchase_stage1'
  },
  purchase_stage1_periods: {
    value: 'purchase_stage1_periods',
    name: 'Закупки: Периоды',
    description: 'План закупок по периодам',
    parent: 'purchase_stage1'
  },
  purchase_stage1_analytics: {
    value: 'purchase_stage1_analytics',
    name: 'Закупки: Аналитика',
    description: 'Аналитика по закупкам',
    parent: 'purchase_stage1'
  },
  purchase_stage1_dynamic: {
    value: 'purchase_stage1_dynamic',
    name: 'Закупки: Динамический план',
    description: 'Динамический план закупок',
    parent: 'purchase_stage1'
  },
  purchase_stage1_versions: {
    value: 'purchase_stage1_versions',
    name: 'Закупки: Версии',
    description: 'Утверждённые версии планов закупок',
    parent: 'purchase_stage1'
  },

  admin: {
    value: 'admin',
    name: 'Администрирование',
    description: 'Доступ к административным функциям',
    route: '/admin',
    icon: 'SettingOutlined'
  },

  admin_users: {
    value: 'admin_users',
    name: 'Управление пользователями',
    description: 'Просмотр и редактирование пользователей, назначение ролей',
    parent: 'admin'
  },

  admin_roles: {
    value: 'admin_roles',
    name: 'Управление ролями',
    description: 'Создание, редактирование ролей и назначение прав',
    parent: 'admin'
  },

  admin_audit: {
    value: 'admin_audit',
    name: 'Журнал аудита',
    description: 'Просмотр журнала действий пользователей',
    parent: 'admin'
  },

  admin_ui_config: {
    value: 'admin_ui_config',
    name: 'Конфигурация интерфейса',
    description: 'Управление настройками внешнего вида: тексты, цвета, заголовки',
    parent: 'admin',
  },

  admin_table_config: {
    value: 'admin_table_config',
    name: 'Настройки таблиц',
    description: 'Управление настройками поведения таблиц: колонки, видимость, формулы',
    parent: 'admin',
  },

  admin_methodology: {
    value: 'admin_methodology',
    name: 'Наполнение методологии',
    description: 'Создание, редактирование и удаление статей раздела «Методология»',
    parent: 'admin',
  },

  methodology: {
    value: 'methodology',
    name: 'Методология',
    description: 'Просмотр раздела «Методология» (вики)',
    route: '/methodology',
    icon: 'ReadOutlined'
  }
} as const;

export type ResourceKey = keyof typeof RBAC_RESOURCES;
export type ResourceValue = typeof RBAC_RESOURCES[ResourceKey]['value'];

export const ROUTE_TO_RESOURCE: Record<string, ResourceKey> = {
  '/sales': 'sales',
  '/purchase': 'purchase',
  '/reconciliation': 'reconciliation',
  '/references': 'references',
  '/methodology': 'methodology',
  '/admin': 'admin'
};

export function getResourceByValue(value: string): ResourceConfig | undefined {
  return Object.values(RBAC_RESOURCES).find(r => r.value === value);
}

export function getChildResources(parentKey: ResourceKey): ResourceConfig[] {
  return Object.values(RBAC_RESOURCES).filter(
    r => 'parent' in r && r.parent === RBAC_RESOURCES[parentKey].value
  );
}

export function getRootResources(): ResourceConfig[] {
  return Object.values(RBAC_RESOURCES).filter(r => !('parent' in r));
}
